import { render, staticRenderFns } from "./BotaoLinkHome.vue?vue&type=template&id=f8474002&scoped=true&"
import script from "./BotaoLinkHome.vue?vue&type=script&lang=js&"
export * from "./BotaoLinkHome.vue?vue&type=script&lang=js&"
import style0 from "./BotaoLinkHome.vue?vue&type=style&index=0&id=f8474002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8474002",
  null
  
)

export default component.exports